import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../styles/AdminSidebar.css";
import logo from "../images/logo.png";

function AdminSidebar({ onToggle, setIsMobileOpen, isMobileOpen }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [isPinned, setIsPinned] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  /* ================= MENU (UPDATED - ONLY ADD ORDERS) ================= */
  const menu = [


    { name: "Admin Orders", path: "/admin/admin-orders", icon: "bi-bag-check" },
    { name: "Shipping Charges", path: "/admin/shipping-charges", icon: "bi-truck" },
    { name: "WhatsApp Inbox", path: "/admin/whatsapp-inbox", icon: "bi-whatsapp" },

    { name: "Home", path: "/admin/home", icon: "bi-house" },
    { name: "About", path: "/admin/about", icon: "bi-info-circle" },
    { name: "Subscribe", path: "/admin/subscribe", icon: "bi-card-list" },
    { name: "Donations", path: "/admin/donations", icon: "bi-wallet2" },
    { name: "Forms", path: "/admin/forms", icon: "bi-file-earmark-text" },
    { name: "Publications", path: "/admin/publications", icon: "bi-journal-text" },
    { name: "VedaPatashala", path: "/admin/vedapatshala", icon: "bi-book" },
    { name: "Magazine", path: "/admin/magazine", icon: "bi-newspaper" },
    { name: "Events", path: "/admin/events", icon: "bi-calendar-event" },
    { name: "FeedBacks", path: "/admin/guest-book", icon: "bi-journal-bookmark" },
    { name: "Gallery", path: "/admin/gallery", icon: "bi-images" },
    { name: "Links", path: "/admin/links", icon: "bi-link-45deg" },
    { name: "Bookings", path: "/admin/bookings", icon: "bi-fire" },
    { name: "Blog & Articles", path: "/admin/blog", icon: "bi-journal-richtext" },
    // { name: "Astrology", path: "/admin/astrology", icon: "bi-stars" },
    { name: "Users", path: "/admin/users", icon: "bi-people" },
    { name: "Subscribers", path: "/admin/subscribers", icon: "bi-person-badge" },
    { name: "Account", path: "/admin/account", icon: "bi-people" },

    { name: "Logout", icon: "bi-box-arrow-left", isLogout: true },
  ];

  /* ================= LOGOUT ================= */
  const handleLogout = () => {
    localStorage.removeItem("adminAuth");
    localStorage.removeItem("adminId");
    navigate("/admin/login");
  };

  /* ================= ACTIVE ROUTE ================= */
  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  const isExpanded = isPinned || isHovered || isMobileOpen;

  useEffect(() => {
    if (onToggle) {
      onToggle(isExpanded);
    }
  }, [isExpanded, onToggle]);

  const handleItemClick = () => {
    setIsPinned(false);
    if (setIsMobileOpen) {
      setIsMobileOpen(false);
    }
  };

  return (
    <>
      {/* OVERLAY */}
      {isExpanded && (
        <div
          className="overlay"
          onClick={() => setIsPinned(false)}
        />
      )}

      {/* TOGGLE */}
      <div
        className={`sidebar-handle ${isExpanded ? "open" : ""}`}
        onClick={() => setIsPinned((prev) => !prev)}
      >
        <span>{isExpanded ? "✕" : "☰"}</span>
      </div>

      {/* SIDEBAR */}
      <aside
        className={`sidebar ${isExpanded ? "show" : "collapsed"}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >

        {/* LOGO */}
        <div className="logo">
          <img src={logo} alt="logo" />
          <h2 className="logo-text">VAITHIKASRI ADMIN</h2>
        </div>

        {/* MENU */}
        <ul className="menu">
          {menu.map((item, i) => (
            <li key={i}>

              {item.isLogout ? (
                <div
                  className="menu-item logout"
                  onClick={() => {
                    handleLogout();
                    handleItemClick();
                  }}
                >
                  <i className={`bi ${item.icon}`} />
                  <span>{item.name}</span>
                </div>
              ) : (
                <Link
                  to={item.path}
                  className={`menu-item ${isActive(item.path) ? "active" : ""
                    }`}
                  onClick={handleItemClick}
                >
                  <i className={`bi ${item.icon}`} />
                  <span>{item.name}</span>
                </Link>
              )}

            </li>
          ))}
        </ul>

      </aside>
    </>
  );
}

export default AdminSidebar;